import { createContext, useContext, FC } from 'react'

type ProductStockContext = {
  warehouseId?: string
  storeId?: string
}

const ProductStockContext = createContext<ProductStockContext>({
  warehouseId: undefined,
  storeId: undefined,
})

export const ProductStockProvider: FC<ProductStockContext> = (props) => {
  const { children, ...value } = props

  return <ProductStockContext.Provider value={value}>{children}</ProductStockContext.Provider>
}

export const useProductStock = () => {
  return useContext(ProductStockContext)
}
